/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {batchGetLocationStatus} from '../api'

export const useMutationBatchGetLocationStatus = createReactQueryMutationHook('batchGetLocationStatus', batchGetLocationStatus)
